import { Label } from './Label';
import PT from 'prop-types';
import s from './styles.scss';
import { Link } from 'react-router-dom';
import { Icon, enums } from 'edrolo-ui';

export const FilterLabels = ({ searchParams, changeSelectionUrl }) => {
  const workingPaths = searchParams.get('working_paths')?.split(',');
  const spiciness = searchParams.get('spiciness')?.split(',');

  const workingPathsMap = {
    '1': <Label.MildPath />,
    '2': <Label.MediumPath />,
    '3': <Label.SpicyPath />,
  };
  const spicinessMap = {
    '1': <Label.Mild />,
    '2': <Label.Medium />,
    '3': <Label.Spicy />,
  };

  if (!workingPaths && !spiciness) {
    return null;
  }

  return (
    <section className={s.filterLabels}>
      <div>
        {workingPaths?.map((path) => (
          <span key={path}>{workingPathsMap[path]}</span>
        ))}
        {spiciness?.map((path) => (
          <span key={path}>{spicinessMap[path]}</span>
        ))}
      </div>

      <Link to={changeSelectionUrl} className={s.link}>
        Change selection
        <Icon name={enums.Icons.CHEVRON_RIGHT} />
      </Link>
    </section>
  );
};

FilterLabels.propTypes = {
  searchParams: PT.object.isRequired,
  changeSelectionUrl: PT.string.isRequired,
};
